import { MONTHS } from '@/constants'

export const countOfDaysAgo = (data) => {
  const comparisonDate = new Date(data)
  const currentDate = new Date()

  const timeDifference = currentDate - comparisonDate

  const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24))

  return daysAgo
}

export const formatDate = (dateString) => {
  const date = new Date(dateString) // Convert to Date object
  const month = MONTHS[date.getUTCMonth()] // Get month abbreviation
  const day = date.getUTCDate() // Get day
  const year = date.getUTCFullYear() // Get year

  return `${month} ${day}, ${year}` // Format the date
}

export const isExpired = (dateString) => {
  const now = new Date() 
  const dateToCheck = new Date(dateString) 

  return dateToCheck < now
}

export const formatTimeLabel = (hour, minute) => {
  const suffix = hour >= 12 ? 'PM' : 'AM'
  const normalizedHour = hour % 12 || 12
  const minuteStr = minute.toString().padStart(2, '0')

  return `${normalizedHour}:${minuteStr} ${suffix}`
}

export const formatHourToMeridiemLabel = (hour) => {
  const h = Number(hour)

  if (Number.isNaN(h)) return ''

  const suffix = h >= 12 ? 'PM' : 'AM'
  const normalizedHour = h % 12 || 12

  return `${normalizedHour}:00 ${suffix.toLowerCase()}`
}

export const formatDateWithTime = (dateString) => {
  const date = new Date(dateString)
  
  // Format date part
  const month = MONTHS[date.getUTCMonth()]
  const day = date.getUTCDate()
  const year = date.getUTCFullYear()

  // Format time part
  let hours = date.getUTCHours()
  const minutes = date.getUTCMinutes().toString().padStart(2, '0')
  const seconds = date.getUTCSeconds().toString().padStart(2, '0')
  const ampm = hours >= 12 ? 'PM' : 'AM'
  
  // Convert hours to 12-hour format
  hours = hours % 12
  hours = hours ? hours : 12 // Handle midnight (0)
  
  return `${month} ${day}, ${year} • ${hours}:${minutes}:${seconds} ${ampm} EDT`
}

export const timeAgo = (dateString) => {
  const date = new Date(dateString)
  const now = new Date()
  const diffInSeconds = Math.floor((now - date) / 1000)

  if (diffInSeconds < 60) {
    return diffInSeconds <= 1 ? 'just now' : `${diffInSeconds} seconds ago`
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60)
  if (diffInMinutes < 60) {
    return diffInMinutes === 1 ? 'a minute ago' : `${diffInMinutes} minutes ago`
  }

  const diffInHours = Math.floor(diffInMinutes / 60)
  if (diffInHours === 1) {
    return 'an hour ago'
  }
  if (diffInHours > 1 && diffInHours < 24) {
    return 'recently'
  }

  const diffInDays = Math.floor(diffInHours / 24)
  if (diffInDays < 7) {
    return diffInDays === 1 ? 'a day ago' : `${diffInDays} days ago`
  }

  const diffInWeeks = Math.floor(diffInDays / 7)
  if (diffInWeeks < 4) {
    return diffInWeeks === 1 ? 'a week ago' : `${diffInWeeks} weeks ago`
  }

  const diffInMonths = Math.floor(diffInDays / 30)
  if (diffInMonths < 12) {
    return diffInMonths === 1 ? 'a month ago' : `${diffInMonths} months ago`
  }

  const diffInYears = Math.floor(diffInDays / 365)
  return diffInYears === 1 ? 'a year ago' : `${diffInYears} years ago`
}
